import axios from "../../utils/apiClient";

const baseURLMV = process.env.REACT_APP_REST_API_BASE_URL + "/v1/manage-visit";

export const updateAction = (dto) => {
  return axios
    .post(baseURLMV + `/update`, dto, {
      headers: { "Content-Type": "application/json" },
    })
}